import Vue from 'vue';
import store from 'store';
import inViewport from 'in-viewport';
import { decode, isTablet } from 'utils/general';
import { listProductsEventData } from 'lib/tracking';
import datalayer from 'lib/datalayer';
import on from 'dom-event';
import debounce from 'lodash.debounce';

export default (el) =>
  new Vue({
    el,
    store,
    name: 'Get The Look',
    mounted() {
      inViewport(this.$el, () => {
        this.trackView();
      });
    },
    computed: {
      productsDecoded() {
        const productsData =  JSON.parse(decode(this.$el.dataset.productsList));
        return productsData.map((p, index) => ({...p, index: index}));
      },
    },
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'get-the-look-products': () => import('./get-the-look-products.vue'),
      'product-card': () => import('../product-card/product-card.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    methods: {
      async trackView() {
        const { products, hasBundleBuilder } = await listProductsEventData(
          this.productsDecoded,
          {
            origin: document.body.dataset.origin,
            originProduct: document.body.dataset.originProduct,
          },
        );
        let eventData = {
          ecommerce: {
            item_list_id: 'get-the-look',
            item_list_name: this.$el.dataset.heading || 'Get the look',
            items: products,
          },
        };
        if (hasBundleBuilder) {
          eventData = {
            ...eventData,
            site_section: window.__GLOBAL__.siteSection,
            component_name: 'get-the-look',
            bundle_type: 'bundle builder',
          }
        }
        datalayer.dataLayerPush('view_item_list', eventData);
      },
    },
  });
